import type React from "react";
import {
  createContext,
  type Dispatch,
  type SetStateAction,
  useState,
} from "react";
import {
  type ApplicationsConfig,
  AuthMode,
  type Config,
} from "../interfaces/Config";

// Context Typing
interface ConfigContext {
  config: Omit<Config, "theme"> & Partial<ApplicationsConfig>;
  setConfig: Dispatch<SetStateAction<Omit<Config, "theme">>>;
}

// Initial State
const initialState: Omit<Config, "theme"> = {
  versioning: 0,
  declinaison: "",
  client_name: "",
  specimenVariation: false,
  apiUrls: {
    match: "",
    endpoints: {
      auth: "",
      content: "",
      assetsProxy: "",
    },
  },
  activate_contentPage: false,
  features: {
    classCode: true,
  },
  pages: [],
  auth: {
    mode: AuthMode.DirectAccess,
    rightImage: "",
    registerURL: "",
    createAccountUrl: "",
    teacherAuthButton: "",
    studentAuthButton: "",
  },
  recommendations: {},
  logos: {
    avatar: "",
    header_client: "",
    endPlaylistIcon: "",
    footer_client: "",
    footer_evidenceb: "",
  },
  contact: "",
  developedBy: "",
  logoutUrl: [],
  ai: {} as any,
  displayedDateFormat: "D/MM/YY",
  footer: {
    socialNetwork: [],
  },
};

// Context init
const configStore = createContext<ConfigContext>({
  config: initialState,
  setConfig: () => null,
});

// Provider init
const { Provider } = configStore;

// Final setup
const ConfigProvider = ({ children }: { children: React.ReactNode }) => {
  const [config, setConfig] = useState(initialState);
  return <Provider value={{ config, setConfig }}>{children}</Provider>;
};

export { ConfigProvider, configStore };
